import { Mail, MapPin, Phone } from "lucide-react";
import { Logo } from "@/components/Logo";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import {
  Email,
  EmailHref,
  FirmName,
  FooterDescription,
  MapsUrl,
  NavLinks,
  Phones,
  ServiceCategories,
  WhatsAppDisplay,
  buildWhatsAppUrl,
} from "@/data/SiteContent";

export default function Footer() {
  const CurrentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-gold/25 bg-ink text-white/70">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 py-16 sm:px-8 md:grid-cols-2 lg:grid-cols-4 lg:px-16">
        <div>
          <Logo />
          <p className="mt-5 text-sm leading-relaxed text-white/60">{FooterDescription}</p>
        </div>

        <nav aria-label="Enlaces rápidos">
          <h3 className="font-serif text-lg text-white">Enlaces rápidos</h3>
          <ul className="mt-5 space-y-2.5">
            {NavLinks.map((pLink) => (
              <li key={pLink.Id}>
                <a
                  href={pLink.Href}
                  data-testid={`footer-link-${pLink.Id}`}
                  className="text-sm transition-colors duration-300 hover:text-gold"
                >
                  {pLink.Label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h3 className="font-serif text-lg text-white">Servicios principales</h3>
          <ul className="mt-5 space-y-2.5">
            {ServiceCategories.map((pCategory) => (
              <li key={pCategory.Id}>
                <a
                  href="#servicios"
                  className="text-sm transition-colors duration-300 hover:text-gold"
                >
                  {pCategory.Label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-serif text-lg text-white">Contacto</h3>
          <ul className="mt-5 space-y-3 text-sm">
            {Phones.map((pPhone) => (
              <li key={pPhone.Href}>
                <a
                  href={pPhone.Href}
                  data-testid="footer-phone-link"
                  className="flex items-center gap-2.5 transition-colors duration-300 hover:text-gold"
                >
                  <Phone className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" />
                  {pPhone.Label}
                </a>
              </li>
            ))}
            <li>
              <a
                href={buildWhatsAppUrl()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-link"
                className="flex items-center gap-2.5 transition-colors duration-300 hover:text-gold"
              >
                <WhatsAppIcon className="h-4 w-4 shrink-0 text-gold" />
                {WhatsAppDisplay}
              </a>
            </li>
            <li>
              <a
                href={EmailHref}
                data-testid="footer-email-link"
                className="flex items-center gap-2.5 break-all transition-colors duration-300 hover:text-gold"
              >
                <Mail className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" />
                {Email}
              </a>
            </li>
            <li>
              <a
                href={MapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-maps-link"
                className="flex items-center gap-2.5 transition-colors duration-300 hover:text-gold"
              >
                <MapPin className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" />
                Poás, Alajuela, Costa Rica
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <p className="mx-auto max-w-7xl px-4 py-6 text-center text-xs text-white/50 sm:px-8 lg:px-16">
          © {CurrentYear} {FirmName}. Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
}
